import { https } from "./api";

export default class {
  constructor() {
    this.instance = https("/preregistrations");
  }

  searchByDate = date => {
    return this.instance({
      method: "GET",
      url: `/${date.inicialDate}/${date.finalDate}/searchbydate`
    });
  };

  searchPreWithLaunch = () => {
    return this.instance({
      method: "GET",
      url: `/searchPreWithLaunch`
    });
  };

  searchInstallmentPaid = (month, year) => {
    return this.instance({
      method: "GET",
      url: `/${month}/${year}/searchInstallmentPaid`
    });
  };

  searchInstallmentPaidSquad = (codUser, month, year) => {
    return this.instance({
      method: "GET",
      url: `/${codUser}/${month}/${year}/searchInstallmentPaidSquad`
    });
  };

  getCommissionSquad = (codUser, month, year) => {
    return this.instance({
      method: "GET",
      url: `/${codUser}/${month}/${year}/commissionSquad`
    });
  };

  searchByAttendance = (coligateId, localId, attendanceId) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${localId}/${attendanceId}/searchbyattendance`
    });
  };

  getPreRegistration = (coligateId, preRegistrationId) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${preRegistrationId}`
    });
  };

  getUnknownCEP = (coligateId, filialId) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${filialId}/cep`
    });
  };

  getScholarships = (coligateId, preRegistrationId) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${preRegistrationId}/scholarships`
    });
  };

  getSubjects = (coligateId, preRegistrationId) => {
    return this.instance({
      method: "GET",
      url: `${coligateId}/${preRegistrationId}/classes`
    });
  };

  create = data => {
    return this.instance({
      method: "POST",
      url: "/",
      data
    });
  };

  audit = data => {
    return this.instance({
      method: "POST",
      url: "/audit",
      data
    });
  };

  divergenceStage = data => {
    return this.instance({
      method: "POST",
      url: "/divergenceStage",
      data
    });
  };

  advance = (data, preRegistrationId) => {
    return this.instance({
      method: "POST",
      url: `${preRegistrationId}/advance`,
      data
    });
  };

  disposal = (data, preRegistrationId) => {
    return this.instance({
      method: "PUT",
      url: `${preRegistrationId}/disposal`,
      data
    });
  };

  getAdmissionModes = () => {
    return this.instance({
      method: "GET",
      url: "/admissionModes"
    });
  };

  getDisposalReasons = () => {
    return this.instance({
      method: "GET",
      url: "/disposal/reasons"
    });
  };

  cancel = (data, preRegistrationId) => {
    return this.instance({
      method: "PUT",
      url: `${preRegistrationId}/cancel`,
      data
    });
  };

  confirm = (data, preRegistrationId) => {
    return this.instance({
      method: "PUT",
      url: `${preRegistrationId}/confirm`,
      data
    });
  };

  addScholarship(data) {
    return this.instance({
      method: "POST",
      url: "/schoolarship",
      data
    });
  }

  getCommissionInfo = (user, mes, ano) => {
    return this.instance({
      method: "GET",
      url: `/commissionInfo/${mes}/${ano}/${user}`
    });
  };
}
